import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/categories/water-drop.svg")